import { notFound } from '@tanstack/react-router';
import { SHIRES, type Shire, type ShireId } from './electorate-shires';
import { SHIRE_CONTENT, type ShireContent } from '../../data/shire-content';

const VALID_IDS = new Set(SHIRES.map((s) => s.id));

export interface ShireLoaderData {
  shire: Shire;
  content: ShireContent;
}

export function loadShire(name: string): ShireLoaderData {
  if (!VALID_IDS.has(name as ShireId)) throw notFound();
  const id = name as ShireId;
  const shire = SHIRES.find((s) => s.id === id)!;
  return { shire, content: SHIRE_CONTENT[id] };
}

export function makeShireSubPageHead(
  loaderData: ShireLoaderData | undefined,
  topic: string,
  description: string,
) {
  if (!loaderData) return { meta: [{ title: `${topic} — Warren-Blackwood` }] };
  const { shire } = loaderData;
  const title = `${topic} — Shire of ${shire.name} | Warren-Blackwood`;
  return {
    meta: [
      { title },
      { name: 'description', content: description },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
    ],
  };
}
